import { render, staticRenderFns } from "./domaine-paul-pernot.vue?vue&type=template&id=12ff9189&scoped=true"
import script from "./domaine-paul-pernot.vue?vue&type=script&lang=js"
export * from "./domaine-paul-pernot.vue?vue&type=script&lang=js"
import style0 from "./domaine-paul-pernot.vue?vue&type=style&index=0&id=12ff9189&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff9189",
  null
  
)

export default component.exports